module.exports = new __parcel__URL__("line-chart-testing.75b26c7f.svg").toString();